import { z } from 'zod';

export const syncedChatInstanceModel = z.object({
  id: z.number(),
  identifier: z.string(),
  userIdentifier: z.string(),
  name: z.string().nullable(),
  isDeleted: z.boolean(),
  createdAt: z.coerce.date(),
  contextData: z.unknown(),
  brandIdentifier: z.string().nullable().optional(),
});

export const syncedChatInstanceQueryModel = z.object({
  id: z.number(),
  identifier: z.string(),
  chatInstanceId: z.number(),
  value: z.string(),
  rating: z.number().nullable(),
  createdOn: z.coerce.date(),
  structuredFeedback: z.unknown(),
  notes: z.string().nullable(),
  feedbackUpdatedOn: z.coerce.date().nullable(),
  citations: z.unknown().array(),
  response: z.unknown(),
  parentIdentifier: z.string().nullable(),
  contextData: z.unknown(),
  suggestedFollowups: z.string().array(),
  promptIdentifier: z.string().nullable().optional(),
  status: z.string().nullable().optional(),
  durationMs: z.number().int().nullable().optional(),
  tokenCount: z.number().int().nullable().optional(),
  inputTokenCount: z.number().int().nullable().optional(),
  outputTokenCount: z.number().int().nullable().optional(),
  llmModel: z.string().nullable().optional(),
});

export const chatSyncDataPayloadModel = z.object({
  chatInstances: z.array(syncedChatInstanceModel),
  chatQueries: z.array(syncedChatInstanceQueryModel),
});
